'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ActiveElement = require('../core/ActiveElement');

var _UILayer = require('../layer/UILayer');

var _UILayer2 = _interopRequireDefault(_UILayer);

var _ModalDialogTransitions = require('./ModalDialogTransitions');

var _focusStylesListener = require('../listeners/focusStylesListener');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Based on https://github.com/twbs/bootstrap/blob/v3.3.6/dist/js/bootstrap.js
function measureScrollbar() {
  var scrollDiv = document.createElement('div');
  scrollDiv.className = 'uiFullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

exports.default = _react2.default.createClass({
  displayName: 'UIFullScreen',

  propTypes: {
    children: _react.PropTypes.element.isRequired,
    rootNode: _react.PropTypes.object
  },

  statics: {
    layerCount: 0,
    NO_SCROLL_CLASS: 'uiFullScreenBackground',
    originalBodyPaddingRight: '',
    restoreBackgroundScrollingTimeout: null
  },

  getInitialState: function getInitialState() {
    return {
      clonedChild: null
    };
  },
  componentWillMount: function componentWillMount() {
    this._lastFocus = (0, _ActiveElement.getActiveElement)();
    this.setState({
      clonedChild: _react2.default.cloneElement(this.getChild(), {
        open: true
      })
    });
  },
  componentDidMount: function componentDidMount() {
    this.constructor.layerCount += 1;
    if (this.constructor.layerCount === 1) {
      clearTimeout(this.constructor.restoreBackgroundScrollingTimeout);
      this.disableBackgroundScrolling();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({
      clonedChild: _react2.default.cloneElement(_react2.default.Children.only(nextProps.children), {
        open: true
      })
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    this.constructor.layerCount -= 1;
    if (this.constructor.layerCount === 0) {
      this.constructor.restoreBackgroundScrollingTimeout = setTimeout(this.restoreBackgroundScrolling, this.getUnmountDelay());
    }
  },
  getUnmountDelay: function getUnmountDelay() {
    // If the immediate child of the UIFullScreen is a UIModalDialog, its props
    // will determine how long we wait before unmounting it (to account for
    // "leave" transitions). Otherwise, getTransitionDuration will return the
    // default modal transition duration.
    return (0, _ModalDialogTransitions.getTransitionDuration)(this.getChild().props);
  },
  getChild: function getChild() {
    return _react2.default.Children.only(this.props.children);
  },
  handleLayerUnmount: function handleLayerUnmount() {
    if (this._lastFocus) {
      if ((0, _focusStylesListener.isPageInKeyboardMode)()) {
        this._lastFocus.focus();
      }
      this._lastFocus = null;
    }
  },
  disableBackgroundScrolling: function disableBackgroundScrolling() {
    var _this = this;

    this.addFauxScrollbar();
    [document.documentElement, document.body].forEach(function (el) {
      return el.classList && el.classList.add(_this.constructor.NO_SCROLL_CLASS);
    });
  },
  restoreBackgroundScrolling: function restoreBackgroundScrolling() {
    var _this2 = this;

    this.removeFauxScrollbar();
    [document.documentElement, document.body].forEach(function (el) {
      return el.classList && el.classList.remove(_this2.constructor.NO_SCROLL_CLASS);
    });
  },
  addFauxScrollbar: function addFauxScrollbar() {
    var bodyHasScrollbar = document.body.clientWidth < window.innerWidth;
    if (bodyHasScrollbar) {
      var scrollbarWidth = measureScrollbar() + 'px';

      // To avoid changing the body width when we disable scrollbar, we replace
      // the scrollbar with padding of equal width.
      this.constructor.originalBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollbarWidth;
    }
  },
  removeFauxScrollbar: function removeFauxScrollbar() {
    document.body.style.paddingRight = this.constructor.originalBodyPaddingRight;
  },
  render: function render() {
    var rootNode = this.props.rootNode;

    return _react2.default.createElement(
      _UILayer2.default,
      {
        onUnmount: this.handleLayerUnmount,
        rootNode: rootNode,
        unmountDelay: this.getUnmountDelay()
      },
      this.state.clonedChild
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dialog/UIFullScreen.js
// module id = 95
// module chunks = 0